export default __webpack_public_path__ + "static/media/100DaysofALXSE.15afc303.png";